import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'
import dayjs from 'dayjs'
import CopyToClipboard from 'react-copy-to-clipboard'

import style from './Confirm.module.scss'

import IconCheckOn from '@Ui/images/common/IconCheckOn.svg'
import IconCheckOff from '@Ui/images/common/IconCheckOff.svg'
import LogoDBInsurance from '@Ui/images/myhouse/LogoDBInsurance'
import { MODAL_BUTTON_INFO, MODAL_BUTTON_TYPE, MODAL_HANDLER_TYPE, MODAL_INFO, MODAL_TYPE } from '@Root/contants/myhouseModal'
import useModal from '@Hooks/myhouse/useModal'
import useBoardRegister from '@Hooks/myhouse/board/useBoardRegister'
import innerHtml from '@Root/utils/innerHtml'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { MYHOUSE_AUTHENTICATION_CATEGORY_TYPE, MYHOUSE_AUTHENTICATION_TYPE, MYHOUSE_REGISTER_PAGE } from '@Root/contants/myhouseRegister'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'
import { DATE_FORMAT } from '@Root/contants'
import useToast from '@Hooks/myhouse/useToast'
import { PROMOTION_TOAST } from '@Root/contants/myhousePromotion'
import { TOAST_AFTER_EVENT } from '@Root/contants/myhouseToast'

const cx = className.bind(style)

const Confirm: React.FC = () => {
  const { close, modal, setConfirmFlag, setConfirmModal, setCancelModal } = useModal()
  const { show } = useToast()
  const { initFetchStatus } = useBoardRegister()
  const history = useHistory()
  const {
    isOpened,
    type,
    title: _title,
    phoneList: _phoneList,
    myhouseNo: _myhouseNo,
    complexNo: _complexNo,
    promotionPeriod: _promotionPeriod,
    nclickConfirm: _nclickConfirm,
    nclickCancel: _nclickCancel,
    address: _address,
  } = modal

  const { vertical, isNewType, address, title, desc, linkText, phoneList, buttonType, myhouseNo, complexNo, promotionPeriod, nclickConfirm, nclickCancel } = MODAL_INFO(type, {
    title: _title,
    phoneList: _phoneList,
    myhouseNo: _myhouseNo,
    complexNo: _complexNo,
    promotionPeriod: _promotionPeriod,
    nclickConfirm: _nclickConfirm,
    nclickCancel: _nclickCancel,
    address: _address,
  })

  const hasButton = buttonType !== MODAL_BUTTON_TYPE.NONE && !!buttonType

  const parsedDesc =
    desc
      ?.replaceAll('{startDate}', dayjs(promotionPeriod?.start).format(DATE_FORMAT.YYYYMD_THREE_DOT))
      ?.replaceAll('{endDate}', dayjs(promotionPeriod?.end).format(DATE_FORMAT.MD_TWO_DOT)) || desc

  const [timeoutId, setTimeoutId] = useState(0)
  const [isCheck, setIsCheck] = useState(false)

  useEffect(() => {
    if (isOpened) {
      window.clearTimeout(timeoutId)
    }

    if (isOpened && !hasButton) {
      setTimeoutId(
        window.setTimeout(() => {
          initFetchStatus()
          close()
        }, 1500),
      )
      return
    }
  }, [isOpened])

  history.listen((location, action) => {
    if ((action === 'POP' || action === 'PUSH') && hasButton) {
      close()
    }
  })

  const handleClose = (evt: React.SyntheticEvent) => {
    nclickCancel && handleNclick(nclickCancel, evt)
    if (type === MODAL_TYPE.AUTH_OWNER) {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/${myhouseNo}`
    }
    if (type === MODAL_TYPE.NPAY_AUTHENTICATION_SUCCESS) {
      handleNclick(NCLICK.MY_HOUSE.AUTHENTICATION.RESIDENT_NPAY.DONE, evt)
    }

    /*무료보험 프로모션 추가부분 시작(7.17 이후 제거)*/
    if (type === MODAL_TYPE['우리집 프로모션 종료 시']) {
      if (isCheck) {
        localStorage.setItem('myhouse:promotion:end:close', 'Y')
      }
    }
    /*무료보험 프로모션 추가부분 끝*/

    setCancelModal(type)
    close()
  }

  const handleAction = (evt: React.SyntheticEvent) => {
    nclickConfirm && handleNclick(nclickConfirm, evt)

    if (type === MODAL_TYPE['우리집 등록 중복']) {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/${myhouseNo}`
      return
    }

    if (type === MODAL_TYPE.DELETE_MYHOUSE) {
      setConfirmFlag(true)
    }

    if (type === MODAL_TYPE.CANCEL_WRITING || type === MODAL_TYPE.CANCEL_MODIFY) {
      history.goBack()
    }

    if (type === MODAL_TYPE.DELETE_ARTICLE) {
      setConfirmFlag(true)
    }

    if (type === MODAL_TYPE.MYHOUSE_LIMITED) {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/regist/settings`
    }

    if (type === MODAL_TYPE.MYHOUSE_AUTHENTICATION_REQUIRED) {
      if (_complexNo) {
        window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/complex/${_complexNo}`
      } else {
        window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/${myhouseNo}`
      }
    }

    if (type === MODAL_TYPE.AUTH_OWNER) {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/${myhouseNo}/${MYHOUSE_AUTHENTICATION_CATEGORY_TYPE.OWNER}/${MYHOUSE_AUTHENTICATION_TYPE.CERTIFICATE_OF_REALESTATE_REGISTER}`
    }

    if (type === MODAL_TYPE.AUTH_RETRY_RESIDENT) {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/${myhouseNo}/${MYHOUSE_AUTHENTICATION_CATEGORY_TYPE.RESIDENT}`
    }

    if (type === MODAL_TYPE.AUTH_RETRY_OWNER) {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/auth/${myhouseNo}/${MYHOUSE_AUTHENTICATION_CATEGORY_TYPE.OWNER}/${MYHOUSE_AUTHENTICATION_TYPE.CERTIFICATE_OF_REALESTATE_REGISTER}`
    }

    if (type === MODAL_TYPE.INSURANCE_DELETE_CONFIRM) {
      setConfirmFlag(true)
    }

    if (type === MODAL_TYPE.AUTH_REALNAME_GUIDE) {
      setConfirmFlag(true)
    }

    if (type === MODAL_TYPE.AUTH_MODIFY_LIMITED_URL) {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/${myhouseNo}`
    }

    if (type === MODAL_TYPE.AUTH_MODIFY_ADDRESS) {
      history.push(MYHOUSE_REGISTER_PAGE.ADDRESS_SEARCH)
    }

    if (type === MODAL_TYPE.AUTH_MODIFY_TRADE_TYPE) {
      setConfirmFlag(true)
    }

    setConfirmModal(type)
    close()
  }

  const handleClick = (handlerType?: MODAL_HANDLER_TYPE) => (event: React.SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()

    if (handlerType === MODAL_HANDLER_TYPE.CLOSE) {
      handleClose(event)
      return
    }

    if (handlerType === MODAL_HANDLER_TYPE.ACTION) {
      handleAction(event)
    }
  }

  const handlePopupLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    event.stopPropagation()

    if (type === MODAL_TYPE.AUTH_COMPLETE_OWNER || type === MODAL_TYPE.AUTH_COMPLETE_RESIDENT) {
      window.location.href = `${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/board/form/reviews`
    }
    /* 무료보험 프로모션 추가부분 시작 */
    if (type === MODAL_TYPE['화재보험 무료 가입 신청 완료'] || type === MODAL_TYPE['화재보험 무료 가입 신청 기 완료']) {
      show(PROMOTION_TOAST.LINK_COPY, TOAST_AFTER_EVENT.NONE, '', true)
    }
    /* 무료보험 프로모션 추가부분 끝 */
  }

  const onClickPhoneNo = (event: React.MouseEvent<HTMLButtonElement>, phone: string) => {
    handleNclick(NCLICK.MY_HOUSE.MAIN_INFO.OFFICE_CALL, event)
    if (phone) {
      window.location.href = `tel://${phone}`
    }
  }

  /*무료보험 프로모션 추가부분 시작*/
  const handlePromotionEndPopCheck = (evt: React.SyntheticEvent) => {
    evt.preventDefault()
    setIsCheck(!isCheck)
  }
  /*무료보험 프로모션 추가부분 끝*/

  return (
    <>
      {isOpened && (
        // [D] 파이낸셜팝업 디자인 적용된 경우 type_new 클래스 추가
        <div className={cx('article', vertical ? 'type_vertical' : 'type_horizon', isNewType && 'type_new')}>
          <div className={cx('inner')}>
            <div className={cx('title_wrap', parsedDesc && 'type_text')}>
              <strong className={cx('title')}>
                {/* [D] '우리집 프로모션 종료 시' | '금주 접수 종료' 팝업에 노출 */}
                {(type === MODAL_TYPE['우리집 프로모션 종료 시'] || type === MODAL_TYPE['금주 접수 종료']) && (
                  <span className={cx('logo-db')}>
                    <span className={cx('blind')}>DB 손해보험</span>
                    <LogoDBInsurance width={79} height={22} />
                  </span>
                )}
                {title}
              </strong>
              {address && <p className={cx('address')}>{address}</p>}
              {!!parsedDesc && <p className={cx('text')} {...innerHtml(parsedDesc)} />}
            </div>

            {!!linkText && (
              <>
                {([MODAL_TYPE['화재보험 무료 가입 신청 완료'], MODAL_TYPE['화재보험 무료 가입 신청 기 완료']].includes(type) && (
                  <CopyToClipboard text={'https://neo.land.naver.com/myhouse/introduce'}>
                    <a href="#" className={cx('link')} onClick={handlePopupLinkClick}>
                      {linkText}
                    </a>
                  </CopyToClipboard>
                )) || (
                  <a href="#" className={cx('link')} onClick={handlePopupLinkClick}>
                    {linkText}
                  </a>
                )}
              </>
            )}
            {/* [D] '우리집 프로모션 종료 시' 팝업에 노출 */}
            {type === MODAL_TYPE['우리집 프로모션 종료 시'] && (
              <div className={cx('checkbox')}>
                <input type="checkbox" id="hide" onClick={handlePromotionEndPopCheck} />
                <label htmlFor="hide" className={cx('checkbox-label')}>
                  <span className={cx('icon-check')}>{isCheck ? <IconCheckOn /> : <IconCheckOff />}</span>더 이상 이 팝업을 보지 않겠습니다.
                </label>
              </div>
            )}
            <div className={cx('button_wrap')}>
              {!!phoneList &&
                phoneList.map((phone, index) => (
                  <button type="button" className={cx('myhouse_button', 'type_phone')} key={`phone_${index}`} onClick={(e) => onClickPhoneNo(e, phone)}>
                    {phone} 통화
                  </button>
                ))}

              {hasButton && (
                <>
                  {!!MODAL_BUTTON_INFO[buttonType]?.button1 && (
                    <button
                      type="button"
                      className={cx('myhouse_button', MODAL_BUTTON_INFO[buttonType]?.button1?.className)}
                      onClick={handleClick(MODAL_BUTTON_INFO[buttonType]?.button1?.handlerType)}
                    >
                      {MODAL_BUTTON_INFO[buttonType]?.button1?.title}
                    </button>
                  )}
                  {!!MODAL_BUTTON_INFO[buttonType]?.button2 && (
                    <button
                      type="button"
                      className={cx('myhouse_button', MODAL_BUTTON_INFO[buttonType]?.button2?.className)}
                      onClick={handleClick(MODAL_BUTTON_INFO[buttonType]?.button2?.handlerType)}
                    >
                      {MODAL_BUTTON_INFO[buttonType]?.button2?.title}
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Confirm
